export default "__VITE_ASSET__BDUsUCXn__"